import * as React from 'react';
import clsx from 'clsx';

import {
  withStyles,
  WithStyles,
  List,
  ListItem,
  ListItemText,
  Hidden,
} from '@nelnet/unifi-components-react';

import styles from './styles/subnavstyles';
import usePlatform from '../../hooks/usePlatform';

interface IPlatformSubnavProps extends WithStyles<typeof styles> {
  path: string;
}

const PlatformSubnav: React.FunctionComponent<IPlatformSubnavProps> = ({ classes, path }) => {
  const platform = usePlatform(path);
  const componentsNav =
    platform === 'angular'
      ? 'https://angular.unifi.nelnet.io/components/'
      : `/${platform}/components/`;

  const pgPath = path.replace(/-(theming|react|web)/, '');

  const subnav = [
    {
      url: `/getstarted/${platform}/`,
      value: 'Get Started',
    },
    {
      url: `/getstarted/${platform}/starter-kit/`,
      value: 'Starter Kit',
    },
    {
      url: componentsNav,
      value: 'Components',
    },
    {
      url: `/changelog/${platform}/`,
      value: 'Changelog',
    },
    {
      url: `/theming/${platform}/`,
      value: 'Theming',
    },
  ];

  return (
    <Hidden mdDown={true}>
      <nav aria-label="secondary" className={clsx(classes.root)}>
        <List className={clsx(classes.itemSubnav, classes[platform])} disablePadding key={path}>
          {subnav.map(({ url, value }) => {
            return (
              <ListItem key={url} href={url} className={clsx(pgPath === url && 'active')}>
                <ListItemText primary={value} />
              </ListItem>
            );
          })}
        </List>
      </nav>
    </Hidden>
  );
};

export default withStyles(styles)(PlatformSubnav);
